import axios from 'axios';
import { clearAuthTokens, getRefreshToken } from '@/utils/auth';
import { externalConnections, LOGOUT_REDIRECT_URI_KEY } from '../../constants/Constants';
import { buildCurrentPageUrl } from '@/shared/utils/url.util';

type LogoutReason = 'user_initiated' | 'auth_error';

export async function logout({ reason }: { reason: LogoutReason }) {
  const refreshToken = getRefreshToken();
  clearAuthTokens();

  try {
    await axios.post(externalConnections.loginApiLogout, { refresh_token: refreshToken });
  } catch (error) {
    console.error('Error revoking token', error);
  }

  const redirectTarget =
    reason === 'auth_error' ? buildLogoutUrl(buildCurrentPageUrl()) : externalConnections.logout;

  window.location.replace(redirectTarget);
}

export function buildLogoutUrl(redirectUri: string | null): string {
  const logoutUrlString = externalConnections.logout;

  if (redirectUri !== null && URL.canParse(redirectUri) && URL.canParse(logoutUrlString)) {
    const logoutUrl = new URL(logoutUrlString);
    logoutUrl.searchParams.set(LOGOUT_REDIRECT_URI_KEY, redirectUri);
    return logoutUrl.toString();
  }

  return logoutUrlString;
}

export default logout;
